import { stopStream } from 'components/UserMedia/helpers/track/stopStream';

export class FakeAudioTrack {
  private _audioContext: AudioContext | null;
  private _audioStream: MediaStream | null;
  private _oscillator: OscillatorNode | null = null;
  private _dest: MediaStreamAudioDestinationNode | null;

  get fakeTrack(): MediaStreamTrack | undefined {
    if (!this._audioStream) {
      this._initFakeStream();
    }
    this._statPlaying();
    return this._audioStream?.getAudioTracks()[0];
  }

  public stopFakeStream(): void {
    if (!this._audioStream) {
      return;
    }

    this._oscillator?.stop();
    this._oscillator = null;

    stopStream(this._audioStream);
    this._audioStream = null;

    this._audioContext?.close();
    this._audioContext = null;
  }

  private _statPlaying(): void {
    const oscillator: OscillatorNode | undefined = this._audioContext?.createOscillator();
    if (!this._dest) {
      return;
    }

    oscillator?.connect(this._dest);
    oscillator?.start();
  }

  private _initFakeStream(): void {
    if (this._audioStream) {
      this.stopFakeStream();
    }

    this._audioContext = new AudioContext();
    this._dest = this._audioContext.createMediaStreamDestination();

    this._audioStream = this._dest.stream;
  }
}
